import {
    FETCH_ATHLETE_SESSIONS_SUCCEEDED,
    FETCH_SESSION_DETAILS_SUCCEEDED,

    SET_FEED_ITEMS,
    UPDATE_FEED_ENTRY_ITEM,
    UPDATE_FEED_COMPLETE_ITEM,

    SIGN_OUT_SUCCEEDED,
} from 'shared_redux/actions';

import { Model, fk, oneToOne, many, attr } from 'redux-orm';

// Helper function to upsert athlete session data
const upsertAthleteSession = (AthleteSessions, athleteSessionData) => {
    AthleteSessions.upsert({
        session_id: athleteSessionData.session_id,
        athlete_id: athleteSessionData.athlete_id,
        microcycle_session_id: athleteSessionData.microcycle_session_id,
        program_schedule_id: athleteSessionData.program_schedule_id,
        date: athleteSessionData.date,
        program_name: athleteSessionData.program_name,
        microcycle_number: athleteSessionData.microcycle_number,
        session_number: athleteSessionData.session_number,
        program_id: athleteSessionData.program_id,
    });
};

class AthleteSessions extends Model {

    static reducer(action, AthleteSessions, session) {
        switch (action.type) {
            case FETCH_ATHLETE_SESSIONS_SUCCEEDED:
                for (var athlete_session of action.payload) {
                    upsertAthleteSession(AthleteSessions, athlete_session);
                }
                break;

            case FETCH_SESSION_DETAILS_SUCCEEDED:
                // Update the existing athlete session with full details
                upsertAthleteSession(AthleteSessions, action.payload);
                break;

            case SET_FEED_ITEMS:
                action.feed_items.forEach(i => {
                    AthleteSessions.upsert(i.athlete_session);
                });
                break;

            case UPDATE_FEED_ENTRY_ITEM:
            case UPDATE_FEED_COMPLETE_ITEM:
                AthleteSessions.upsert(action.feed_item.athlete_session);
                break;

           case SIGN_OUT_SUCCEEDED:
                AthleteSessions.all().delete();
                break;
        }
    }

}
AthleteSessions.modelName = 'AthleteSessions';

AthleteSessions.options = {
    idAttribute: 'session_id',
};

AthleteSessions.fields = {
    session_id: oneToOne({
        to: 'Sessions',
        as: 'session',
        relatedName: 'athlete_session',
    }),
    athlete_id: fk({
        to: 'Athletes',
        as: 'athlete',
        relatedName: 'athlete_sessions',
    }),
    microcycle_session_id: fk({
        to: 'MicrocycleSessions',
        as: 'microcycle_session',
        relatedName: 'athlete_sessions',
    }),
    program_schedule_id: fk({
        to: 'ProgramSchedules',
        as: 'program_schedule',
        relatedName: 'athlete_sessions',
    }),
    date: attr(),
    program_name: attr(),
    microcycle_number: attr(),
    session_number: attr(),
    program_id: fk({
        to: 'Programs',
        as: 'program',
        relatedName: 'athlete_sessions',
    }),
};

export default AthleteSessions;
